import React, { Component } from "react";
import {
  message,
  List,
  Card,
  Button,
  Icon,
  Spin,
  Row,
  Col,
  Modal,
  Input,
  Pagination,
  Alert,
} from "antd";
import CurrencyInput from "react-currency-input";
import Scanner from "../components/common/Scanner/Scanner";
import soap_materiais from "../store/soap/zws_app_buscar_materiais.js";
import soap_cadastrar_pesquisa from "../store/soap/zws_app_cadastrar_pesquisa.js";
import soap_buscar_matnr_ean from "../store/soap/zws_app_buscar_matnr_ean.js";
import soap_config from "../store/soap/config.js";
import Camera, { IMAGE_TYPES, FACING_MODES } from "react-html5-camera-photo";
import photo from "../store/soap/photo.js";
const { Search } = Input;

let update = [];

export default class Reasearch extends Component {
  constructor(props) {
    super(props);
    this._onCode = this._onCode.bind(this);
    this.updatePrecoNovoVJ = this.updatePrecoNovoVJ.bind(this);
    this.updatePrecoNovoAT = this.updatePrecoNovoAT.bind(this);
    this.changeUpdateMaterial = this.changeUpdateMaterial.bind(this);
  }

  state = {
    visible: false,
    visibleScanner: false,
    code: "",
    materiais: [],
    materiaisAll: [],
    load: true,
    material: {},
    update: [],
    page: 1,
    limitePage: 10,
    modalPhoto: false,
    takePicture: false,
    labelPhoto: "Tirar foto",
    photo: "",
    itemPhoto: null,
    isUpdatePhoto: false,
    loadingPhoto: true,
    loadingEan: false,
    disabledAtacado: false,
    pesquisa: {},
    range: 0.5,
    isLoadingSave: false,
  };

  async componentDidMount() {
    try {
      document.querySelector("body").style["overscroll-behavior"] = "contain";

      try {
        // ativa localização
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(() => {});
        } else {
          alert("Geolocation is not supported by this browser.");
        }
      } catch (error) {
        alert("É necessário permitir o acesso a localização.");
        window.location.href = window.location.origin;
      }
      if (localStorage.getItem("pesquisa") !== null) {
        const _pesquisa = JSON.parse(localStorage.getItem("pesquisa"));
        this.setState({
          disabledAtacado: !_pesquisa.isAtacado,
          pesquisa: _pesquisa,
        });

        const { data } = await soap_config.getConfig();
        console.log("CONFIG DATA -> ", data);
        this.setState({ range: (data.range || 50) / 100 });
        soap_materiais
          .getMateriais()
          .then(this.loadMateriais)
          .catch((e) => {
            throw e;
          });
      } else {
        throw new Error("NotFound");
      }
    } catch (e) {
      this.setState({
        materiais: [],
        load: false,
      });
      message.warning("Erro ao tentar carregar lista. Tente novamente.");
    }
  }

  componentWillUnmount() {
    document.querySelector("body").style["overscroll-behavior"] = "";
  }

  loadMateriais = (_materiais) => {
    _materiais = _materiais.map((m) => {
      m.PRECO_NOVO_VJ._text = parseFloat(m.PRECO_NOVO_VJ._text);
      m.PRECO_NOVO_VJ._number = parseFloat(m.PRECO_NOVO_VJ._text);
      m.PRECO_NOVO_AT._text = parseFloat(m.PRECO_NOVO_AT._text);
      m.PRECO_NOVO_AT._number = parseFloat(m.PRECO_NOVO_AT._text);
      m.PRECO_NOVO_VJ_PHOTO = m.PRECO_NOVO_VJ._text;
      if (!Number.isNaN(parseFloat(m.PR_DIF._text))) {
        m.PR_DIF = parseFloat(m.PR_DIF._text);
      }
      return m;
    });

    if (this.state.pesquisa.TIPO._text === "S") {
      const category = this.props.history.location.search.replace(
        "?category=",
        ""
      );
      _materiais = _materiais.filter((m) => m.LTEXT._text === category);
    }

    this.setState({
      materiaisAll: _materiais,
      materiais: _materiais.slice(0, this.state.limitePage),
      load: false,
    });
  };

  save = async (e) => {
    if (!this.state.disabledAtacado) {
      // Verifica se PREÇO ATACADO é MENOR que PREÇO VAREJO
      const isValidAtacado = update.filter((item) => {
        return (
          item.PRECO_NOVO_VJ._number > 0 &&
          item.PRECO_NOVO_AT._number > item.PRECO_NOVO_VJ._number
        );
      });
      if (isValidAtacado.length) {
        return message.warning(
          `Preço de atacado não pode ser maior do que varejo, Produto: ${isValidAtacado[0].MAKTX._text}.`
        );
        // -------------------------------------------------------
      }
      //Verifica se PREÇO ATACADO é menor que 70% do PREÇO ORIGINAL do PRODUTO
      const isLowerThan70h = update.filter((item) => {
        return (
          item.PRECO_NOVO_AT._number <
          parseFloat(item.PR_DIF) - parseFloat(item.PR_DIF) * 0.5
        );
      });

      if (isLowerThan70h.length) {
        return message.warning(
          `Preço de atacado não pode ser menor que 50% do valor original do produto ${isLowerThan70h[0].MAKTX._text}`
        );
      }
      //----------------------------------------------------------------------
    }

    if (this.state.pesquisa.FOTO_OBRIG._text) {
      const isPhoto = update.filter((item) => {
        return item.PRECO_NOVO_VJ._number > 0 && !item.IImagem;
      });
      if (isPhoto.length) {
        return message.warning(
          `Foto Obrigatória, Produto: ${isPhoto[0].MAKTX._text}.`
        );
      }
    }

    // Validando se o preço pesquisado está dentro da regra dos 50%
    const isRegraPreco = update.filter((item) => {
      return (
        item.PRECO_NOVO_VJ._number <
          parseFloat(item.PR_DIF * this.state.range) ||
        item.PRECO_NOVO_VJ._number >
          parseFloat(item.PR_DIF * (1 + this.state.range))
      );
    });
    if (isRegraPreco.length) {
      return message.warning(
        `Preço informado está fora dos valores permitidos, Produto: ${isRegraPreco[0].MAKTX._text}.`
      );
    }

    message.loading("salvando...");
    let _materiais = [];
    if (update.length === 0) {
      return message.success("salvo com sucesso.");
    }
    _materiais = update.filter((m) => {
      if (typeof m.PRECO_NOVO_VJ._text === "string") {
        m.PRECO_NOVO_VJ._text = parseFloat(
          m.PRECO_NOVO_VJ._text.replace(/[R$.]/g, "").replace(",", ".")
        );
      }
      if (typeof m.PRECO_NOVO_AT._text === "string") {
        m.PRECO_NOVO_AT._text = parseFloat(
          m.PRECO_NOVO_AT._text.replace(/[R$.]/g, "").replace(",", ".")
        );
      }

      return m.WERKS !== undefined;
    });

    try {
      this.setState({ isLoadingSave: true });
      await soap_cadastrar_pesquisa.postCadastrarPesquisa(_materiais);
      message.success("salvo com sucesso.");
      let _materiais_up = this.state.materiais;
      update.map((up, index) => {
        if (up.WERKS !== undefined && this.state.page + index === index) {
          _materiais_up[index] = up;
        }
        return up;
      });
      this.setState({
        materiais: _materiais_up,
      });
      update = [];
    } catch (e) {
      message.warning("erro ao salvar.");
    } finally {
      this.setState({ isLoadingSave: false });
    }
  };

  saveProdutoAvulso = async (e) => {
    try {
      let _materialAvulso = JSON.parse(JSON.stringify(this.state.material)); //deep copy
      console.log("MATERIAL AVULSO -> ", _materialAvulso);
      _materialAvulso.PRECO_NOVO_VJ._text = _materialAvulso.PRECO_NOVO_VJ._text
        .toString()
        .replace(/[R$.]/g, "")
        .replace(",", ".");

      if (
        _materialAvulso.PRECO_NOVO_VJ._text === "00" ||
        _materialAvulso.PRECO_NOVO_VJ._text.replace(/[ ]/, "") === "0.00"
      ) {
        return message.warning("Informe o valor de varejo.");
      }

      if (!this.state.disabledAtacado) {
        if (typeof _materialAvulso.PRECO_NOVO_AT._text === "string") {
          _materialAvulso.PRECO_NOVO_AT._text =
            _materialAvulso.PRECO_NOVO_AT._text
              .toString()
              .replace(/[R$. ]/g, "")
              .replace(",", ".");
        }

        if (
          _materialAvulso.PRECO_NOVO_AT._text === "00" ||
          _materialAvulso.PRECO_NOVO_AT._text.replace(/[ ]/, "") === "0.00"
        ) {
          return message.warning("Informe o valor de atacado.");
        }
      }

      let PRECO_NOVO_VJ = parseFloat(_materialAvulso.PRECO_NOVO_VJ._number);

      let PRECO_ORIGINAL = null;
      if (!Number.isNaN(parseFloat(_materialAvulso.PR_DIF._text))) {
        PRECO_ORIGINAL = parseFloat(_materialAvulso.PR_DIF._text);
      } else {
        PRECO_ORIGINAL = _materialAvulso.PR_DIF;
      }

      const isRegraPreco =
        PRECO_NOVO_VJ < parseFloat(PRECO_ORIGINAL * this.state.range) ||
        PRECO_NOVO_VJ > parseFloat(PRECO_ORIGINAL * (1 + this.state.range));

      if (
        _materialAvulso.PRECO_NOVO_AT._number >
        _materialAvulso.PRECO_NOVO_VJ._number
      ) {
        return message.warning(
          "O preço do atacado deve ser menor que do varejo."
        );
      }

      if (isRegraPreco) {
        return message.warning(
          `Preço informado está fora dos valores permitidos, Produto: ${_materialAvulso.MAKTX._text}.`
        );
      }

      const isLowerThan70h =
        _materialAvulso.PRECO_NOVO_AT._number <
        parseFloat(_materialAvulso.PR_DIF) -
          parseFloat(_materialAvulso.PR_DIF) * 0.5;

      if (isLowerThan70h) {
        return message.warning(
          `Preço de atacado não pode ser menor que 50% do valor original do produto ${_materialAvulso.MAKTX._text}`
        );
      }

      message.loading("salvando...");
      this.setState({ isLoadingSave: true });
      await soap_cadastrar_pesquisa.postCadastrarPesquisa([_materialAvulso]);
      this.setState({ isLoadingSave: false });
      message.success("salvo com sucesso.");

      let _materiaisAll = [...this.state.materiaisAll];
      let _materiais = [...this.state.materiais];
      _materialAvulso.PRECO_NOVO_VJ._text = parseFloat(
        _materialAvulso.PRECO_NOVO_VJ._text
      );
      _materialAvulso.PRECO_NOVO_AT._text = parseFloat(
        _materialAvulso.PRECO_NOVO_AT._text
      );

      const isMaterial = _materiais.find(
        (material) => material.MATNR._text === _materialAvulso.MATNR._text
      );
      const isMaterialAll = _materiaisAll.find(
        (materialAll) => materialAll.MATNR._text === _materialAvulso.MATNR._text
      );

      if (
        isMaterialAll === undefined &&
        (this.state.pesquisa.TIPO._text === "F" ||
          this.state.pesquisa.TIPO._text === "T" ||
          this.state.pesquisa.TIPO._text === "E") &&
        this.state.page === 1
      ) {
        _materiais.unshift(_materialAvulso);
        if (
          _materiais.length > 0 &&
          _materiais.length > this.state.limitePage
        ) {
          _materiais.pop();
        }
        _materiaisAll.unshift(_materialAvulso);
      } else if (isMaterial !== undefined) {
        isMaterial.PRECO_NOVO_VJ._text = _materialAvulso.PRECO_NOVO_VJ._text;
        isMaterial.PRECO_NOVO_AT._text = _materialAvulso.PRECO_NOVO_AT._text;
      }

      this.setState({
        load: true,
        materiaisAll: _materiaisAll,
        material: {},
        visible: false,
      });

      setTimeout(() => {
        if (this.state.pesquisa.FOTO_OBRIG._text) {
          this.showTakePicture(_materialAvulso, 0);
        }

        this.setState({
          load: false,
          materiais: _materiais,
        });
      }, 1000);
    } catch (error) {
      message.warning("erro ao salvar.");
    }
  };

  updatePrecoNovoVJ = (value, index) => {
    let materiais = this.state.materiais;
    materiais[index].PRECO_NOVO_VJ._text = value;
    materiais[index].PRECO_NOVO_VJ._number = parseFloat(
      value
        .toString()
        .replace(/[R$. ]/g, "")
        .replace(",", ".")
    );
    update[index + this.state.page] = materiais[index];
    this.setState({
      material: materiais,
    });
    // this.updatePrecoNovoAT(value, index)
  };

  updatePrecoNovoAT = (value, index) => {
    let materiais = this.state.materiais;
    materiais[index].PRECO_NOVO_AT._text = value;
    materiais[index].PRECO_NOVO_AT._number = parseFloat(
      value
        .toString()
        .replace(/[R$. ]/g, "")
        .replace(",", ".")
    );
    update[index + this.state.page] = materiais[index];
    this.setState({
      material: materiais,
    });
  };

  changeUpdateMaterial = (value, prop) => {
    let _material = this.state.material;
    _material[prop]._text = value;
    _material[prop]._number = parseFloat(
      value
        .toString()
        .replace(/[R$. ]/g, "")
        .replace(",", ".")
    );
    this.setState({
      material: _material,
    });
  };

  showModal = () => {
    this.setState({
      material: {},
      visible: true,
      visibleScanner: true,
      loadingEan: false,
      offline: window.Offline.state !== "up",
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
      visibleScanner: false,
    });
  };

  showTotal = (total) => {
    return `Total ${total} itens`;
  };

  pageChange = (page) => {
    this.setState({
      load: true,
      page: page,
    });

    setTimeout(() => {
      let skip = (page - 1) * this.state.limitePage;
      let take =
        skip === 0 ? this.state.limitePage : page * this.state.limitePage;
      this.setState({
        load: false,
        materiais: this.state.materiaisAll.slice(skip, take),
      });
    }, 600);
  };

  handleCancel = (e) => {
    this.setState({
      material: {},
      visible: false,
      visibleScanner: false,
      loadingEan: false,
    });
  };

  showTakePicture = (item, index) => {
    item.index = index;
    this.setState({
      modalPhoto: true,
      takePicture: false,
      itemPhoto: item,
      loadingPhoto: true,
      isUpdatePhoto: false,
      photo: "",
    });
    photo
      .getPhoto(this.namePhoto(item))
      .then((photo) => {
        if (photo.data.data64) {
          this.setState({
            photo: photo.data.data64,
            labelPhoto: "Tirar foto",
            isUpdatePhoto: true,
            loadingPhoto: false,
          });
        } else {
          this.setState({
            loadingPhoto: false,
            labelPhoto: "Tirar foto",
          });
        }
      })
      .catch((e) => {
        this.setState({
          loadingPhoto: false,
          labelPhoto: "Tirar foto",
        });
      });
  };

  changeTakePicture = () => {
    this.setState({
      labelPhoto: !this.state.takePicture ? "Ver foto" : "Tirar foto",
      takePicture: !this.state.takePicture,
    });
  };

  handleCancelPhoto = (e) => {
    this.setState({
      modalPhoto: false,
      takePicture: false,
      labelPhoto: "Ver foto",
    });
  };

  namePhoto(item) {
    let name = `WERKS:${item.WERKS._text}-
    CODIGO_GRUPO:${item.CODIGO_GRUPO._text}-
    CONCORRENTE:${item.CONCORRENTE._text}-
    MATNR:${item.MATNR._text}`;
    name = name.replace(/[\n 0]/g, "");
    return `${name}-DATE:${new Date()
      .toISOString()
      .split("T")[0]
      .replace(/[-]/g, "_")}`;
  }

  async handleTakePhoto(dataUri) {
    this.setState({
      labelPhoto: "Tirar foto",
      takePicture: false,
      photo: dataUri,
    });

    let position = {};
    try {
      position = await new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              resolve(position);
            },
            (error) => {
              reject(error);
            }
          );
        } else {
          reject({});
        }
      });
    } catch (error) {
      if (error.coords === undefined) {
        if (error.code && error.code === 1) {
          return alert("Libere a permissão para acessar geolocalização!");
        } else {
          return alert("Erro ao acessar geolocalização!");
        }
      }
    }

    message.loading("salvando foto...");

    let name = this.namePhoto(this.state.itemPhoto);
    let salveImage = {};

    if (!this.state.isUpdatePhoto) {
      salveImage = await new Promise((resolve) => {
        photo
          .postPhoto({
            name: name,
            data64: dataUri,
            geolocation: {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            },
          })
          .then((newImage) => {
            resolve(newImage);
          })
          .catch((error) => {
            resolve("erro ao salvar.");
            message.warning("erro ao salvar.");
          });
      });
    } else {
      salveImage = await new Promise((resolve) => {
        photo
          .putPhoto(name, {
            data64: dataUri,
            geolocation: {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            },
          })
          .then((newImage) => {
            resolve(newImage);
          })
          .catch((error) => {
            resolve("erro ao salvar.");
            message.warning("erro ao salvar.");
          });
      });
    }

    if (salveImage === "erro ao salvar.") {
      return;
    }

    const updateMaterial = this.state.itemPhoto;
    updateMaterial.IImagem = salveImage.data.data64;

    if (typeof updateMaterial.PRECO_NOVO_VJ._text === "string") {
      updateMaterial.PRECO_NOVO_VJ._text = updateMaterial.PRECO_NOVO_VJ._text
        .toString()
        .replace(/[R$. ]/g, "")
        .replace(",", ".");
    }
    if (typeof updateMaterial.PRECO_NOVO_AT._text === "string") {
      updateMaterial.PRECO_NOVO_AT._text = updateMaterial.PRECO_NOVO_AT._text
        .toString()
        .replace(/[R$. ]/g, "")
        .replace(",", ".");
    }

    updateMaterial.PRECO_NOVO_VJ_PHOTO = parseFloat(
      updateMaterial.PRECO_NOVO_VJ._text
    );

    let materiais = this.state.materiais;
    materiais[updateMaterial.index] = updateMaterial;
    update[updateMaterial.index + this.state.page] = updateMaterial;
    soap_cadastrar_pesquisa.postCadastrarPesquisa([updateMaterial]);
    updateMaterial.PRECO_NOVO_VJ._text = parseFloat(
      updateMaterial.PRECO_NOVO_VJ._text
    );
    updateMaterial.PRECO_NOVO_AT._text = parseFloat(
      updateMaterial.PRECO_NOVO_AT._text
    );

    message.success("Foto salva com sucesso.");
    this.setState({
      isUpdatePhoto: true,
      materiais: materiais,
      modalPhoto: false,
    });
  }

  async _onCode(result) {
    if (this.state.loadingEan) {
      return;
    }

    let codeEan = result;
    if (codeEan.codeResult) {
      codeEan = result.codeResult.code;
    }

    this.setState({
      loadingEan: true,
    });

    let _material = this.state.materiaisAll.find((m) => {
      return (
        m.EAN11._text !== undefined && m.EAN11._text === codeEan.toString()
      );
    });

    if (
      _material === undefined &&
      (this.state.pesquisa.TIPO._text === "F" ||
        this.state.pesquisa.TIPO._text === "T" ||
        this.state.pesquisa.TIPO._text === "E")
    ) {
      this.setState({
        visibleScanner: false,
      });
      this.state.pesquisa.EAN11 = {
        _text: codeEan,
      };
      _material = await soap_buscar_matnr_ean.getCodigoEAN(this.state.pesquisa);
      console.log("MATERIAL -> ", _material);
      if (_material === null || _material.MAKTX._text === undefined) {
        _material = undefined;
      }
    }
    _material = _material ? _material : { MAKTX: undefined };
    // Código para injetar a propriedade do preço no valor de R$12,00
    // e poder finalizar a implementação enquanto o webservice
    // do SAP fica pronto. Assim que o WS retornar este campo,
    // remover esta linha
    // _material.PR_DIF = { _text: ' 12,00', _number: 12 };

    this.setState({
      visibleScanner: false,
      material: _material,
      loadingEan: false,
      code: codeEan,
    });
  }

  render() {
    const { limitePage } = this.state;
    let showTotal = this.showTotal;
    return (
      <>
        <Modal
          title="Foto do produto"
          style={{ top: 20 }}
          visible={this.state.modalPhoto}
          onOk={this.changeTakePicture}
          onCancel={this.handleCancelPhoto}
          okText={this.state.labelPhoto}
          cancelText="Fechar"
        >
          {this.state.takePicture && (
            <Camera
              onTakePhoto={(dataUri) => {
                this.handleTakePhoto(dataUri);
              }}
              imageType={IMAGE_TYPES.JPG}
              imageCompression={0.9}
              idealFacingMode={FACING_MODES.ENVIRONMENT}
              isImageMirror={false}
            />
          )}

          {!this.state.takePicture && this.state.loadingPhoto && (
            <h3 style={{ textAlign: "center", margin: "50px" }}>
              Carregando foto...
            </h3>
          )}

          {!this.state.takePicture &&
            this.state.photo === "" &&
            !this.state.loadingPhoto && (
              <h3 style={{ textAlign: "center", margin: "50px" }}>
                Não há foto cadastrada para esse produto.
              </h3>
            )}

          {!this.state.takePicture &&
            this.state.photo !== "" &&
            !this.state.loadingPhoto && (
              <img src={this.state.photo} width="100%" />
            )}
        </Modal>

        <Modal
          title="Scannear produto"
          style={{ top: 20 }}
          visible={this.state.visible}
          onOk={this.saveProdutoAvulso}
          onCancel={this.handleCancel}
          okText="Salvar"
          cancelText="Fechar"
        >
          {!this.state.visibleScanner && this.state.loadingEan && (
            <h3 style={{ textAlign: "center", margin: "50px" }}>
              Buscando produto...
            </h3>
          )}

          {this.state.visibleScanner && !this.state.loadingEan && (
            <div>
              {(!this.state.offline ||
                (this.state.offline &&
                  this.state.pesquisa.TIPO._text === "S")) && (
                <Scanner onDetected={this._onCode} />
              )}
              <Search
                style={{ marginTop: 10 }}
                placeholder="Insira código EAN"
                allowClear
                enterButton="Buscar"
                size="large"
                onSearch={this._onCode}
              />
            </div>
          )}

          {!this.state.visibleScanner &&
            !this.state.loadingEan &&
            this.state.material.MAKTX !== undefined && (
              <Card
                title={this.state.material.MAKTX._text}
                style={{ width: "100%" }}
              >
                <Row className="row-space">
                  {!this.state.disabledAtacado &&
                    this.state.material.PRECO_NOVO_AT._number >
                      this.state.material.PRECO_NOVO_VJ._number && (
                      <Alert
                        message="O preço do atacado deve ser menor que do varejo."
                        type="warning"
                      />
                    )}

                  <Col span={24}>
                    <span style={{ fontSize: "1.2em", color: "#5b5b5b" }}>
                      {" "}
                      <Icon type="shopping-cart" /> Preço
                    </span>
                    <CurrencyInput
                      value={this.state.material.PRECO_NOVO_VJ._text}
                      className="ant-input ant-input-lg"
                      inputType="tel"
                      decimalSeparator=","
                      thousandSeparator="."
                      prefix="R$ "
                      onChangeEvent={(e) => {
                        this.changeUpdateMaterial(
                          e.target.value,
                          "PRECO_NOVO_VJ"
                        );
                        // this.changeUpdateMaterial(
                        //   e.target.value,
                        //   "PRECO_NOVO_AT"
                        // );
                      }}
                    />
                  </Col>
                  <Col span={24} style={{ marginTop: "10px" }}>
                    <span style={{ fontSize: "1.2em", color: "#5b5b5b" }}>
                      {" "}
                      <Icon type="shop" /> Atacado
                    </span>
                    <CurrencyInput
                      value={this.state.material.PRECO_NOVO_AT._text}
                      className="ant-input ant-input-lg"
                      inputType="tel"
                      decimalSeparator=","
                      thousandSeparator="."
                      prefix="R$ "
                      onChangeEvent={(e) => {
                        this.changeUpdateMaterial(
                          e.target.value,
                          "PRECO_NOVO_AT"
                        );
                      }}
                      disabled={this.state.disabledAtacado}
                    />
                  </Col>
                </Row>
              </Card>
            )}

          {!this.state.visibleScanner &&
            !this.state.loadingEan &&
            this.state.material.MAKTX === undefined && (
              <div>
                <h3 style={{ textAlign: "center", margin: "50px" }}>
                  Produto não encontrado na lista. <br />
                  EAN: {this.state.code}
                </h3>
                <Search
                  style={{ marginTop: 10 }}
                  placeholder="Insira código EAN"
                  allowClear
                  enterButton="Buscar"
                  size="large"
                  onSearch={this._onCode}
                />
              </div>
            )}
        </Modal>

        <div
          style={{
            position: "sticky",
            top: "0px",
            zIndex: "99",
            background: "#fff",
          }}
        >
          <Row type="flex" justify="start">
            <Col span={11}>
              <Button
                icon="barcode"
                shape="round"
                size="large"
                block
                style={{ marginTop: 8 }}
                onClick={this.showModal}
                className="dma-secundary"
              >
                Scannear
              </Button>
            </Col>
            <Col span={12} offset={1}>
              <Button
                shape="round"
                type="primary"
                icon="save"
                size="large"
                style={{ marginTop: 8 }}
                onClick={this.save}
                block
                loading={this.state.isLoadingSave}
                className="dma-primary"
              >
                Salvar
              </Button>
            </Col>
          </Row>

          {this.state.materiaisAll.length > limitePage && (
            <Pagination
              style={{ marginTop: 8 }}
              total={this.state.materiaisAll.length}
              pageSize={limitePage}
              showTotal={showTotal}
              onChange={this.pageChange}
            />
          )}
        </div>

        {this.state.load && <Spin className="spin-dma" />}

        <div className="listProdutos">
          {!this.state.load && (
            <List
              dataSource={this.state.materiais}
              split={false}
              renderItem={(item, index) => (
                <List.Item>
                  <Card
                    title={`${item.MAKTX._text} - ${parseInt(
                      item.MATNR._text
                    )}`}
                    style={{ width: "100%" }}
                    extra={
                      <div>
                        {this.state.pesquisa.FOTO_OBRIG._text && (
                          <span
                            style={{
                              color: "#e87700",
                              fontSize: 12,
                              fontWeight: "bold",
                              margin: "0px 5px",
                            }}
                          >
                            (Foto Obrigatória.)
                          </span>
                        )}

                        <Button
                          type="text"
                          size="small"
                          disabled={item.PRECO_NOVO_VJ._text === 0}
                          onClick={(e) => {
                            this.showTakePicture(item, index);
                          }}
                        >
                          <Icon type="camera" />
                        </Button>
                      </div>
                    }
                  >
                    {item.PRECO_NOVO_VJ_PHOTO !== 0 &&
                      item.PRECO_NOVO_VJ._number !==
                        item.PRECO_NOVO_VJ_PHOTO && (
                        <Alert
                          message="O preço está diferente da foto do produto, envie um nova foto para registro."
                          type="info"
                        />
                      )}
                    {!this.state.disabledAtacado &&
                      item.PRECO_NOVO_AT._number >
                        item.PRECO_NOVO_VJ._number && (
                        <Alert
                          message="O preço do atacado deve ser menor que do varejo."
                          type="warning"
                        />
                      )}

                    <Row className="row-space">
                      <Col span={24}>
                        <span style={{ fontSize: "1.2em", color: "#5b5b5b" }}>
                          {" "}
                          <Icon type="shopping-cart" /> Preço
                        </span>
                        <CurrencyInput
                          value={item.PRECO_NOVO_VJ._text}
                          className="ant-input ant-input-lg"
                          inputType="tel"
                          decimalSeparator=","
                          thousandSeparator="."
                          prefix="R$ "
                          key={index}
                          onChangeEvent={(e) => {
                            this.updatePrecoNovoVJ(e.target.value, index);
                          }}
                        />
                      </Col>
                      <Col span={24} style={{ marginTop: "10px" }}>
                        <span style={{ fontSize: "1.2em", color: "#5b5b5b" }}>
                          {" "}
                          <Icon type="shop" /> Atacado
                        </span>
                        <CurrencyInput
                          value={item.PRECO_NOVO_AT._text}
                          className="ant-input ant-input-lg"
                          inputType="tel"
                          decimalSeparator=","
                          thousandSeparator="."
                          prefix="R$ "
                          onChangeEvent={(e) => {
                            this.updatePrecoNovoAT(e.target.value, index);
                          }}
                          disabled={this.state.disabledAtacado}
                        />
                      </Col>
                    </Row>
                  </Card>
                </List.Item>
              )}
            />
          )}
        </div>
      </>
    );
  }
}
